function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.000666618 0.667323H1.334V2.37199C2.05484 1.80632 2.92627 1.46537 3.83959 1.39167C4.75292 1.31797 5.66774 1.51478 6.46996 1.95755C7.27217 2.40032 7.92629 3.06946 8.35074 3.88152C8.77519 4.69358 8.95118 5.61263 8.85677 6.52405C8.76236 7.43547 8.40173 8.29893 7.81984 9.00675C7.23795 9.71457 6.46057 10.2354 5.58463 10.5044C4.70868 10.7733 3.77295 10.7784 2.89412 10.5191C2.01529 10.2597 1.23226 9.7474 0.642667 9.04599L1.722 8.25599C2.14993 8.73789 2.70838 9.0854 3.32973 9.25645C3.95109 9.42751 4.60871 9.41477 5.22298 9.21978C5.83725 9.02479 6.38182 8.65591 6.79076 8.1578C7.1997 7.65969 7.45548 7.05372 7.52713 6.41324C7.59877 5.77276 7.48321 5.12525 7.19444 4.54909C6.90567 3.97293 6.45607 3.49284 5.90007 3.16694C5.34407 2.84104 4.70552 2.68331 4.06172 2.71284C3.41793 2.74237 2.7965 2.95789 2.27267 3.33332H4V4.66666H0V0.666656L0.000666618 0.667323Z",
  fill: "#4B556F"
});

var SvgReset = function SvgReset(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reset.f0ec3428.svg";
export { ForwardRef as ReactComponent };